import { Button } from '@/app/common/components/button/Button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shad/ui/tooltip'
import { Award } from 'lucide-react'
import { useState } from 'react'
import {
  FundablePurse,
  FundAwardedStudentsDialog,
} from './fund-awarded-students-dialog'

type Props = {
  purse: FundablePurse
  programId: number
  className?: string
  variant?: 'primary' | 'outline'
  size?: 'sm' | 'md'
  disabledReason?: string | null
}

/**
 * The single per purse funding action. ServiceNow owns which students are awarded and for how
 * much, so there is nothing to select, sequence or preview before triggering it.
 */
export function FundAwardedStudentsAction({
  purse,
  programId,
  className,
  variant = 'outline',
  size = 'sm',
  disabledReason = null,
}: Props) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span tabIndex={disabledReason ? 0 : undefined}>
              <Button
                type="button"
                variant={variant}
                size={size}
                className={className}
                disabled={Boolean(disabledReason)}
                onClick={() => setIsDialogOpen(true)}
              >
                <Award className="size-4 mr-2" aria-hidden="true" />
                Fund Awarded Students
              </Button>
            </span>
          </TooltipTrigger>
          <TooltipContent>
            {disabledReason ?? 'Fund every student in Awarded status'}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <FundAwardedStudentsDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        purse={purse}
        programId={programId}
      />
    </>
  )
}
